/**
 * @readonly
 * @enum  {string}
 */
export const AllOptionEnum = {
  All: 'All',
  Zero: 'Zero',
  None: 'None',
};

/**
 * @readonly
 * @enum  {string}
 */
export const YesNoAllEnum = {
  Yes: 'Yes',
  No: 'No',
  All: 'All',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/PropEnums.js